import { mediaUrl } from "./media-url";

export const HERO_REVEAL_MUSIC_TRACKS = Array.from({ length: 5 }, (_, index) => {
  const number = String(index + 1).padStart(2, "0");
  return { id: `hero-reveal-${number}`, url: mediaUrl(`/assets/audio/hero-reveal/hero-reveal-${number}.mp3`) };
});

export function heroRevealMusicUrl(trackId: string | undefined) {
  return HERO_REVEAL_MUSIC_TRACKS.find((track) => track.id === trackId)?.url;
}

export function randomHeroRevealMusicTrackId(random = Math.random) {
  const sample = Math.max(0, Math.min(0.9999999999999999, random()));
  return HERO_REVEAL_MUSIC_TRACKS[Math.floor(sample * HERO_REVEAL_MUSIC_TRACKS.length)].id;
}
